import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { Loader2, Search, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { InviteDialog, InvitationStatus, ResendInviteButton } from "@/components/InviteDialog";

const ROLE = { volunteer: "Vrijwilliger", planner: "Planner", admin: "Beheerder" };

export default function VolunteersPage() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { setUsers((await api.get("/users")).data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const filtered = users.filter((u) => u.name.toLowerCase().includes(q.toLowerCase()) || (u.email || "").includes(q.toLowerCase()));

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-6" data-testid="volunteers-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight">Vrijwilligers</h1>
          <p className="text-muted-foreground mt-1" data-testid="volunteer-count">{users.length} personen in de organisatie.</p>
        </div>
        <InviteDialog onUpdated={load} />
      </div>
      <div className="relative max-w-sm">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Zoek op naam of e-mail" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="volunteer-search" />
      </div>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Naam</TableHead>
              <TableHead className="hidden sm:table-cell">Contact</TableHead>
              <TableHead>Rol</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map((u) => (
              <TableRow key={u.id} data-testid={`volunteer-row-${u.id}`}>
                <TableCell className="font-medium">{u.name}</TableCell>
                <TableCell className="hidden sm:table-cell text-sm text-muted-foreground">
                  <span className="flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> {u.email}</span>
                  {u.phone && <span className="flex items-center gap-1 mt-0.5"><Phone className="w-3.5 h-3.5" /> {u.phone}</span>}
                </TableCell>
                <TableCell><span className="text-xs font-semibold px-2 py-1 rounded-full bg-muted">{ROLE[u.role]}</span></TableCell>
                <TableCell>
                  <div className="flex flex-wrap items-center gap-2">
                    <InvitationStatus employee={u} />
                    <ResendInviteButton employee={u} onUpdated={load} />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
